/**
 * Web stand-in for `react-native-device-info`.
 *
 * The app only calls `getIpAddress()` (authSlice, to stamp the login audit
 * trail). A browser cannot read the client's LAN address, so we return the
 * documented "unknown" sentinel that the native module also uses when the
 * address cannot be resolved. Everything else is derived from navigator.
 */

const UNKNOWN_IP = '0.0.0.0';

function userAgent(): string {
  return typeof navigator !== 'undefined' && navigator.userAgent ? navigator.userAgent : 'web';
}

const DeviceInfo = {
  async getIpAddress(): Promise<string> {
    return UNKNOWN_IP;
  },
  getIpAddressSync(): string {
    return UNKNOWN_IP;
  },
  async getUniqueId(): Promise<string> {
    return 'web';
  },
  getUniqueIdSync(): string {
    return 'web';
  },
  async getDeviceName(): Promise<string> {
    return userAgent();
  },
  getDeviceNameSync(): string {
    return userAgent();
  },
  getSystemName(): string {
    return 'Web';
  },
  getSystemVersion(): string {
    return typeof navigator !== 'undefined' ? navigator.appVersion : '';
  },
  getBrand(): string {
    return 'browser';
  },
  getModel(): string {
    return 'browser';
  },
  getApplicationName(): string {
    return 'ZenBasket POS';
  },
  getVersion(): string {
    return '';
  },
  getBuildNumber(): string {
    return '';
  },
  async isEmulator(): Promise<boolean> {
    return false;
  },
  isTablet(): boolean {
    return false;
  },
  async hasNotch(): Promise<boolean> {
    return false;
  },
};

/**
 * react-native-device-info exposes every getter both on the default export and
 * as a named export. authSlice.ts imports `getDeviceName` by name, so the shim
 * has to offer both shapes.
 */
export const getIpAddress = DeviceInfo.getIpAddress;
export const getIpAddressSync = DeviceInfo.getIpAddressSync;
export const getUniqueId = DeviceInfo.getUniqueId;
export const getUniqueIdSync = DeviceInfo.getUniqueIdSync;
export const getDeviceName = DeviceInfo.getDeviceName;
export const getDeviceNameSync = DeviceInfo.getDeviceNameSync;
export const getSystemName = DeviceInfo.getSystemName;
export const getSystemVersion = DeviceInfo.getSystemVersion;
export const getBrand = DeviceInfo.getBrand;
export const getModel = DeviceInfo.getModel;
export const getApplicationName = DeviceInfo.getApplicationName;
export const getVersion = DeviceInfo.getVersion;
export const getBuildNumber = DeviceInfo.getBuildNumber;
export const isEmulator = DeviceInfo.isEmulator;
export const isTablet = DeviceInfo.isTablet;
export const hasNotch = DeviceInfo.hasNotch;

export default DeviceInfo;
